import { Injectable } from '@angular/core';
import { ProjectDetail, Projects } from './ProjectCover';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  selected_proj:ProjectDetail;
  constructor() {
    this.selected_proj=null;
   }

   setCurrentproject(proj){
     this.selected_proj = proj;
   }

   getSelectedProject(){
     return this.selected_proj;
   }

   getAllProjects():ProjectDetail[]{
     let project_details=[]
    let droneresponse_cover:ProjectDetail={
      id:Projects.Human_Drone,
      title: "Multi Drone Emergency Response System (DroneResponse)",
      cover_image:"../../../assets/projects/project_covers/DroneResponseCover.png",
      short_desc:" A system that deploys autonomous Unmanned Aerial Vehicles(UAVs) or Drones that interact with human \
       first responders in various emergency response missions such as river search-and-rescue and fire-surveillance.",
      start_year:"2019",
      end_year:"Present",
      keywords:["Human Drones Collaboration","User Interface", "Autonomy"],
      abstract:` The use of semi-autonomous Unmanned Aerial Vehicles (UAV) to support emergency response scenarios, 
      such as fire surveillance and search and rescue, offers the potential for huge societal benefits. However, 
      designing an effective solution in this complex domain represents a "wicked design" problem, requiring a careful balance between 
      trade-offs associated with drone autonomy versus human control, mission functionality versus safety, and the diverse needs of different stakeholders. 
      This paper focuses on designing for situational awareness (SA) using a scenario-driven, participatory design process. 
      We developed SA cards describing six common design-problems, known as SA demons, and three new demons of importance to our domain. 
      We then used these SA cards to equip domain experts with SA knowledge so that they could more fully engage in the design process. 
      We designed a potentially reusable solution for achieving SA in multi-stakeholder, multi-UAV, emergency response applications.`
    }
    project_details.push(droneresponse_cover)
    
    

    

    let safa_cover:ProjectDetail={
      id:Projects.SAFA,
      title: "Visualizing the Evolution of Software Systems",
      cover_image:"../../../assets/projects/project_covers/visualization.png",
      short_desc:"Visualize the changes in software artifacts such as Design Definitions, Requirements, and Code\
         as the software system evolves. The visualization aims to help analysts to argue the safety of the\
          system based on changes in the software.",
      start_year:"Summer 2018",
      end_year:"2019",
      keywords:["Visualization","Software Engineering","Safety Analysis"],
      abstract:`Safety Assurance Cases (SACs) are increasingly used
      to guide and evaluate the safety of software-intensive systems.
      They are used to construct a hierarchically organized set of
      claims, arguments, and evidence in order to provide a structured
      argument that a system is safe for use. However, as the system
      evolves and grows in size, a SAC can be difficult to maintain. In
      this paper we utilize design science to develop a novel solution
      for identifying areas of a SAC that are affected by changes to the
      system. Moreover, we generate actionable recommendations for
      updating the SAC, including its underlying artifacts and trace
      links, in order to evolve an existing safety case for use in a
      new version of the system. Our approach, Safety Artifact Forest
      Analysis (SAFA), leverages traceability to automatically compare
      software artifacts from a previously approved or certified version
      with a new version of the system. We identify, visualize, and
      explain changes in a Delta Tree. We evaluate our approach using
      the Dronology system for monitoring and coordinating the actions
      of cooperating, small Unmanned Aerial Vehicles. Results from a
      user study show that SAFA helped users to identify changes that
      potentially impacted system safety and provided information that
      could be used to help maintain and evolve a SAC"`
      
    }
    project_details.push(safa_cover)

    let human_ai_interaction_cover:ProjectDetail={
      id:Projects.Human_AI,
      title: "Human Interaction with AI-based Applications",
      cover_image:"../../../assets/projects/project_covers/humanAICover.png",
      short_desc:"Designing techniques for humans to better collaborate with the AI system.\
       This project aims to learn the impact of AI Recommendations and explanations on humans' cognitive biases.",
      start_year:"August-2020",
      end_year:"Present",
      keywords:["Human-AI Collaboration","Human Behavior Analysis", "Cognitive Load Analysis"],
      abstract:"Coming Soon!!!!! "
      
    }
    project_details.push(human_ai_interaction_cover)

    let sentiment_analysis_cover:ProjectDetail={
      id:Projects.Sentiment_Analysis,
      title: "Sentiment Analysis",
      cover_image:"../../../assets/projects/project_covers/SentimentAnalysisCover.jpeg",
      short_desc:"In this project, we examine various classification and natural language processing techniques to predict human sentiments in textual data.",
      start_year:"2014",
      end_year:"2015",
      keywords:["Sentiment Analysis","Natural Language Processing", "Classification"],
      abstract:`With the ever increasing social networking and online marketing sites, the reviews and blogs obtained
      from those, act as an important source for further analysis and improved decision making. These reviews
      are mostly unstructured by nature and thus, need processing like classification or clustering to provide a
      meaningful information for future uses. These reviews and blogs may be classified into different polarity
      groups such as positive, negative, and neutral in order to extract information from the input dataset.
      Supervised machine learning methods help to classify these reviews. 
      In this project, we explore various classification and NLP techniques to predict human sentiments in textual data.`
      
    }
    project_details.push(sentiment_analysis_cover)

    return project_details;
   }
}
